export default __webpack_public_path__ + "0aa782876cfe1fde99b547ee086093f0.svg";